<template>
  <v-app>
    <!--<v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Vuetify</span>
        <span class="font-weight-light">MATERIAL DESIGN</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
        <span class="mr-2">Latest Release</span>
      </v-btn>
    </v-app-bar>-->

    <!--<v-content>-->
			<CargaInicial v-if="!$root.accesoInicialCargado"></CargaInicial>
			<Acceso v-else-if="$root.accesoInicialCargado && (!$root.datos || !$root.datos.id)"></Acceso>
			<Inicio v-else-if="$root.accesoInicialCargado && $root.datos && $root.datos.id"></Inicio>
			<div v-else><p>Error: 2398</p></div>
    <!--</v-content>-->
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
//import CargaInicial from './views/CargaInicial';
//import Acceso from './views/Acceso';
import CargaInicial from '../../cliente-comun/componentes/CargaInicial';
import Acceso from '../../cliente-comun/componentes/Acceso';
import Inicio from './views/Inicio';

export default {
  name: 'App',
  components: {
		CargaInicial,
		Acceso,
		Inicio
  },
  data: () => ({
    //
	}),
	methods: {
		//
	}
};
</script>
